import { useState } from "react"
import { useInterval } from "usehooks-ts"
import { getCurrentMinuteBucketMs, getDelayUntilNextMinuteBucketMs } from "~shared/timeBucket"

export function useTimeBucket(enabled: boolean): number {
	const [, setTick] = useState(0)

	useInterval(
		() => {
			setTick(currentTick => currentTick + 1)
		},
		enabled ? getDelayUntilNextMinuteBucketMs() : null,
	)

	return getCurrentMinuteBucketMs()
}
